export default "__VITE_PUBLIC_ASSET__a39587f7__"